// src/services/DashboardService.js
import http from './Http'; 

const DashboardService = {
  /**
   * Obtiene el consolidado de sesiones agrupado por Nivel, Grado y Área.
   * @param {Object} filtros - region, provincia, distrito, tipo_sesion, estado, etc.
   */
  obtenerConsolidado: async (filtros) => {
    try {
      // Usamos tu instancia 'http'. 
      // La baseURL y el token de Authorization se inyectan solos.
      const response = await http.get('/dashboard/consolidado', {
        params: filtros
      });
      
      return response.data;
    } catch (error) {
      console.error("Error al cargar el consolidado del Dashboard:", error);
      throw error;
    }
  }
};

export default DashboardService;